import { Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { OrderNowComponent } from '../order-now/order-now.component';
import { DigitalService } from '../../../core/services/digital.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Message } from '../../../core/class/message';

//Gói
interface Package {
  packageId: string; // Id gói cước
  packageCode: String; // Mã gói cước
  packageName: string; // Tên gói cước
  quantity: number; // Tổng số lượng gói cước - Sum(listPackage.quantity)
  price: number; // Đơn giá gói cước (maxlength = 9 kí tự)
  duration: number; // Thời hạn gói cước (maxlength = 9 kí tự)
  amount: number; // Tổng tiền hàng - Sum(listPackage.amount)
}

//Model Save
interface ModelSaveOrder {
  transactionId: string; // Mã giao dịch thanh toán qua cổng thanh toán online -- Nếu thanh toán COD thì giá trị này null
  customerName: string; // Họ tên khách hàng 
  phone: string; // Số điện thoại
  email: string; // Email khách hàng
  provinceId: number; // Id Tỉnh/ Thành phố
  provinceName: string;  // Tên Tỉnh
  districtId: number; // Id Quận/ Huyện 
  districtName: string; // Tên Huyện
  wardId: number;  // Id Phường/ Xã
  wardName: string;  // Tên xã
  deliveryAddress: string; // Địa chỉ nhận hàng (maxlength = 255 kí tự)
  installType: number; // Hình thức lắp đặt: (0: Viettel lắp ) (1: Tự lắp đặt mặc định 1 với ViettelCA)
  installPrice: number; // Chi phí lắp đặt (maxlength = 9 kí tự) -- Set: null
  paymentMethod: number; //Phương thức thanh toán (1: COD) (2: VTPAY) (3: BANKPLUS) (4: VISA) (5: ATM) (6: OTHER)
  paymentTypeStr: string;
  feeShipping: number; // Phí vận chuyển  (maxlength = 9 kí tự)
  note: string; // Ghi chú (maxlength = 255 kí tự)
  total: number; // Tổng chi phí đơn hàng (maxlength = 9 kí tự)
  invoice: number; // Xuất hóa đơn hay không: (1: Có) (0: Không) (Nếu giá trị bằng 1 sẽ validate bắt buộc nhập các trường: taxCode, companyName, companyAddress)
  taxCode: string; // Mã số thuế
  companyName: string;  // Tên công ty
  companyAddress: string; // Địa chỉ công ty
  quantity: number; // Số lượng
  amount: number; // Tổng tiền của từng gói sản phẩm
  discount: number; // Giảm giá
  vat: number; // Thuế 
  orderDate: Date;  // Ngày đặt hàng
  type: number;
  otp: number;
  orderCode: string;
  id: number;
  listPackage: Package[];  //Gói
}

@Component({
  selector: 'app-confirm-order',
  templateUrl: './confirm-order.component.html',
  styleUrls: ['./confirm-order.component.scss']
})
export class ConfirmOrderComponent implements OnInit {
  modelSaveOrder: ModelSaveOrder;
  objectPackage: Package = {
    packageId: '', // Id gói cước
    packageCode: '', // Mã gói cước
    packageName: '', // Tên gói cước
    quantity: 0, // Tổng số lượng gói cước - Sum(listPackage.quantity)
    price: 0, // Đơn giá gói cước (maxlength = 9 kí tự)
    duration: 0, // Thời hạn gói cước (maxlength = 9 kí tự)
    amount: 0 // Tổng tiền hàng - Sum(listPackage.amount)
  }
  listPackageTemp: any[] = [];
  typePayment: number;
  total: number = null;
  totalOrderAmount: number = null;
  totalCostOrder: number = null;
  isDateTimeNowConfirmOrder: Date = new Date();

  constructor(
    private digitalService: DigitalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private message: Message
  ) {
    this.modelSaveOrder = {
      transactionId: "",
      customerName: "",
      phone: "",
      email: "",
      provinceId: null,
      provinceName: "",
      districtId: null,
      districtName: "",
      wardId: null,
      wardName: "",
      deliveryAddress: "",
      installType: 0,
      installPrice: 0,
      paymentMethod: null,
      paymentTypeStr: "",
      feeShipping: 0,
      note: "",
      total: 0,
      invoice: 0,
      taxCode: "",
      companyName: "",
      companyAddress: "",
      quantity: 0,
      amount: 0,
      discount: 0,
      vat: 0,
      orderDate: null,
      type: 0,
      otp: 0,
      orderCode: "",
      id: 0,
      listPackage: []
    }

    //get typePayment
    this.activatedRoute.queryParams.subscribe(params => {
      this.typePayment = Number(params.typePayment);
    });
  }

  ngOnInit() {
    this.modelSaveOrder = JSON.parse(localStorage.getItem('modelSaveOrder'));
    this.totalMoneyOrder();
  }

  //tổng số lượng
  //Tổng tiền đơn hàng
  //Tổng chi phí đơn hàng
  totalMoneyOrder() {
    const model = JSON.parse(localStorage.getItem('modelSaveOrder'));
    if (model !== null && model !== undefined && model !== '') {
      model.listPackage.forEach(x => {
        this.total = this.total + Number(x.quantityOrder);
        this.totalOrderAmount = Number(this.totalOrderAmount) + Number(this.typePayment === 1 ? x.servicePriceToQuantityCOD : x.servicePriceToQuantityViettelPay);
        this.totalCostOrder = this.totalOrderAmount;
        return x;
      });
    } else {
      return;
    }
  }

  saveOrder() {
    const model = JSON.parse(localStorage.getItem('modelSaveOrder'));
    model.listPackage.forEach(x => {
      this.objectPackage = {
        packageId: x.packageId,
        packageCode: x.packageCode,
        packageName: x.description,
        quantity: x.quantityOrder,
        price: x.servicePrice,
        duration: x.month,
        amount: this.typePayment === 1 ? x.servicePriceToQuantityCOD : x.servicePriceToQuantityViettelPay
      }
      this.listPackageTemp.push(this.objectPackage);
    });

    this.modelSaveOrder.listPackage = this.listPackageTemp;
    this.modelSaveOrder.paymentMethod = this.typePayment;
    this.typePayment == 1 ? this.modelSaveOrder.paymentTypeStr = "COD" : this.modelSaveOrder.paymentTypeStr = "VTPay";
    this.modelSaveOrder.amount = this.totalCostOrder == null ? 0 : this.totalCostOrder;

    //call service.
    if (this.typePayment === 1) {
      this.digitalService.saveOrderService(this.modelSaveOrder).subscribe(rs => {
        if (rs !== '' && rs !== null && rs !== undefined) {
          const response = JSON.parse(rs);
          this.modelSaveOrder.orderCode = response.orderCode;
          this.modelSaveOrder.id = response.id;

          //lưu lại vào local storage.
          localStorage.setItem('modelSaveOrder', JSON.stringify(this.modelSaveOrder));
          localStorage.setItem('_orderCode', JSON.stringify(this.modelSaveOrder.orderCode));
          localStorage.setItem('_phone', JSON.stringify(this.modelSaveOrder.phone));
          this.toNavigateConfirmOTP();
        }
      }, (error) => {
        console.log(error);
        this.toastr.error(this.message.getMessage('messages.expired_date_order'));
      });
    }
    else {
      this.digitalService.saveOrderService(this.modelSaveOrder).subscribe(rs => {
        // console.log(rs)
        if (rs !== null && rs !== undefined && rs !== '') {
          this.toNavigateSanBOXPaymentVT(rs);
        }
        else {
          // console.log("URL: ", rs);
        }
      }, (error) => {
        console.log(error);
        this.toastr.error(this.message.getMessage('messages.expired_date_order'));
      });
    }
  }

  toNavigateConfirmOTP() {
    this.router.navigate(['/digital/confirm-otp']);
  }

  toNavigateSanBOXPaymentVT(url) {
    location.href = url;
  }

}
